import { getHeaders } from './authentication'
import { Surgery } from '../types/surgery'

interface State {
  surgeries: Surgery[]
  surgery: null | Surgery
  rowsPerPage: number
  totalCount: null
  filter?: any
  error: null | string
  fetching: boolean
  searchResults: {} | {
    surgeries: Surgery[]
  }
}

let initialState: State = {
  surgery: null,
  surgeries: [],
  searchResults: {},
  rowsPerPage: 10,
  totalCount: null,
  error: null,
  fetching: false,
  filter: {}
}

export const resetError = () => {
  return { type: `RESET_ERROR` }
}

const createFetchThunk = (verb: string, url: string, method: string, data?: any) => {
  return ({
    types: [verb, `${verb}_SUCCESS`, `${verb}_FAILURE`],
    payload: {
      request: {
        url, method, headers: getHeaders(), data
      }
    }
  })
}

export const search = (searchTerm, searchQuery) => {
  const queryString = searchQuery && Object.keys(searchQuery)
    .map(key => `${key}=${searchQuery[key]}`)
    .join('&');

  const url = queryString
    ? `/surgeries/search?${queryString}`
    : '/surgeries/search';
  return createFetchThunk(`SEARCH_SURGERY`, url, 'POST', { name: searchTerm })
}
export const resetSearch = () =>  ({ type: `RESET_SEARCH` })

export const updateSurgery = (surgeryID, data) => createFetchThunk(`UPDATE_SURGERY`, `/surgeries/${surgeryID}`, 'PUT', data)

export const getSurgeries = (name, page = 0, filter = {}) => {
  let url = `/surgeries?limit=${initialState.rowsPerPage}&page=${page}&${new URLSearchParams(filter).toString()}`
  if (name) url = `/surgeries?name=${name}`
  return createFetchThunk(`GET_SURGERIES`, url, 'GET', filter)
}

export const getSurgery = (surgeryID) => createFetchThunk(`GET_SURGERY`, `/surgeries/${surgeryID}`, 'GET')

export const setFilter = (filters) => {
  return { type: `SET_FILTER`, payload: { filter: filters } }
}

export const resetSingleSurgery=()=>{
  return {type:'RESET_SURGERY'}
}

const surgeriesReducer = (state: State = initialState, action): State => {
  switch (action.type) {
    case `SEARCH_SURGERY`:
      return { ...state }
    case `SEARCH_SURGERY_SUCCESS`:
      return {
        ...state,
        searchResults: {
          surgeries: action.payload.data.data,
          rowsPerPage: action.payload.data.pagination.limit,
          totalCount: action.payload.data.pagination.total_count,
          currentPage: action.payload.data.pagination.page,
        },
      }
    case `SEARCH_SURGERY_FAILURE`:
      return { ...state, searchResults: {} }
    case `RESET_SEARCH`:
      return { ...state, searchResults: {} }  
    case `RESET_ERROR`:
      return {
        ...state, error: null
      }
    case `SET_FILTER`:
      return {
        ...state, filter: action.payload.filter
      }  
    case `UPDATE_SURGERY`:
      return {
        ...state, fetching: true, error: null
      }
    case `UPDATE_SURGERY_SUCCESS`:
      return {
        ...state,
        surgery: { ...state.surgery, ...action.payload.data.data[0] }, 
        fetching: false, error: "Updated Successfully"
      }
    case `UPDATE_SURGERY_FAILURE`:
      return {
        ...state,
        fetching: false, error: action.error.data
      }
    case `GET_SURGERIES`:
      return {
        ...state,
        surgeries: [], error: null, searchResults: {},
        fetching: true
      }
    case `GET_SURGERIES_SUCCESS`:
      return {
        ...state,
        fetching: false,
        surgeries: action.payload.data.data,
        totalCount: action.payload.data.pagination.total_count
      }
    case `GET_SURGERIES_FAILURE`:
      return {
        ...state,
        surgeries: [],
        fetching: false,
        error: action.error.response ? action.error.response.data.error : action.error
      }
    case `GET_SURGERY`:
      return {
        ...state,
        surgery: null,
        fetching: true
      }
    case `GET_SURGERY_SUCCESS`:
      return {
        ...state,
        fetching: false,
        surgery: action.payload.data.data[0]
      }
    case `GET_SURGERY_FAILURE`:
      return {
        ...state,
        error: action.error,
        fetching: false
      }
    case 'RESET_SURGERY':
      return {
        ...state,
        surgery: null
      };
    default:
      return state
  }
}

export default surgeriesReducer;
